import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackChangedVideoVolume.meta';

export type TrackChangedVideoVolumeParams = {
  id: string;
  volume: number;
};

export const useTrackChangedVideoVolume = () => {
  const { track } = useAnalyticsUtilities();

  const trackChangedVideoVolume = useCallback(
    (params: TrackChangedVideoVolumeParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackChangedVideoVolume };
};
